export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6814.8acfac59.jpg";